// extracted by mini-css-extract-plugin
export default {"bento":"bento_bento__ExLam","inner":"bento_inner__3sJ+r"};